import React, { useState } from 'react';
import { resetPassword } from '../../../utils/auth.controller'; 
import styles from './Login.module.css'; 
import CreateForm from '../../Design/Forms/CreateForm'; // Import CreateForm component
import { FormFields } from '../../Design/Forms/FormJson'; // Import FormFields to access resetPasswordFields
import BackgroundImage from '../../../assets/Background.png';


function PasswordReset() {
  const [formData, setFormData] = useState({
    newPassword: '',
    confirmPassword: ''
  });
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  // Handle password reset logic
  const handlePasswordReset = async (e) => {
    e.preventDefault();

    // Clear any previous error or success message
    setError('');
    setSuccessMessage('');

    // Check if the passwords match
    if (formData.newPassword !== formData.confirmPassword) {
      setError('Passwords do not match.');
      return;
    }

    // Extract the token from the URL path
    const path = window.location.pathname;
    const token = path.split('/').pop().slice(6); // Assuming token is part of the URL path after /reset/

    if (!token) {
      setError('Invalid reset token.');
      return;
    }

    try {
      // Call the resetPassword function with token and new password
      await resetPassword(token, formData.newPassword);
      setSuccessMessage('Password has been reset successfully! Redirecting...');
      setTimeout(() => {
        window.location.href = '/login'; 
      }, 1500);
    } catch (error) {
      setError(error.message); // Display any error that occurs
    }
  };

  return (
    <div className={styles.loginPage} style={{ backgroundImage: `url(${BackgroundImage})` }}>
      <div className={styles.loginImage}></div> {/* You can add a background image if needed */}

      {/* Right Side Form */}
      <div className={styles.loginFormContainer}>
        <div className={styles.loginForm}>
          <h2>Reset Your Password</h2>

          {/* Show error message if there's any */}
          {error && <p className={styles.errorMessage}>{error}</p>}

          {/* Show success message if password reset is successful */}
          {successMessage && <p className={styles.successMessage}>{successMessage}</p>}

          {/* Use CreateForm to dynamically generate the fields */}
          <CreateForm
            formData={formData}
            setFormData={setFormData}
            onSubmit={handlePasswordReset}
            text="Reset Password"
            fields={FormFields.resetPasswordFields} // Pass resetPasswordFields from FormFields
          />
        </div>
      </div>
    </div>
  );
}

export default PasswordReset;
